import { format } from 'date-fns'

export function formatDateTime(value) {
  return format(Date.parse(`${value}Z`), 'MMM d, yyyy · h:mm aa')
}
